import { fetcher } from "../helpers/global";

export function fetchFeaturedCauses(fundCategoryId) {
  return fetcher(
    "GET",
    `rest/featured-causes/${fundCategoryId}`,
    { _format: "json" },
    {
      accept: "application/json",
    }
  );
}
